import rules from '../../../../plugins/form-rules';

export default {
  startDate: [rules.required],
  endDate: [rules.required],
};
